import { request, response } from "../../proto/bundle";
import { getConnectionPool } from "../../core/connectionPool";
import { checkMigrate } from "../../init/sdkInit";

export async function getQuestion(email: string) {
    const pool = await getConnectionPool();
    if (!pool) {
        throw new Error("Connection pool is not initialized");
    }
    const req = request.Request.create({
        id: null,
        reqCreateTime: Date.now(),
        listQuestions: request.ListQuestions.create({
            email
        })
    });
    let resp = await pool.sendAndWait(req);
    checkMigrate(resp.listQuestions.status)
    if (resp.listQuestions.status != 0) {
        return new Error("Couldnt fetch Questions!!")
    }
    return resp.listQuestions.question;
}
